// Boot-time detection for the language-study sites (kept tiny and dependency-free:
// index.js imports this eagerly, so nothing from the lazy study chunk may leak in).
//
// Order of precedence:
//   1. Hostname — spanish.* / german.* subdomains are the production entry points.
//   2. ?lang=es|de — local dev + deploy previews (?lang=off exits study mode).
//   3. sessionStorage — keeps the choice across reloads in the same tab, since SPA
//      navigation drops the query param. Tab-scoped on purpose: a stray value must
//      not permanently turn the main marketing domain into the study app.
//
// react-snap prerenders against localhost with no param/storage, so the marketing
// site always prerenders in marketing mode.
const STORAGE_KEY = 'sls-study-lang';
const LANGS = ['es', 'de'];

export default function detectStudyLanguage() {
  if (typeof window === 'undefined') return null;
  const host = window.location.hostname.toLowerCase();
  if (host.startsWith('spanish.')) return 'es';
  if (host.startsWith('german.')) return 'de';

  let stored = null;
  try {
    stored = window.sessionStorage.getItem(STORAGE_KEY);
  } catch (e) { /* storage unavailable */ }

  const param = new URLSearchParams(window.location.search).get('lang');
  if (param === 'off') {
    try { window.sessionStorage.removeItem(STORAGE_KEY); } catch (e) { /* noop */ }
    return null;
  }
  if (LANGS.includes(param)) {
    try { window.sessionStorage.setItem(STORAGE_KEY, param); } catch (e) { /* noop */ }
    return param;
  }
  return LANGS.includes(stored) ? stored : null;
}

// Used by the dev language switcher (study chunk) — same storage the detector reads.
export function setDevStudyLanguage(lang) {
  try {
    if (lang) window.sessionStorage.setItem(STORAGE_KEY, lang);
    else window.sessionStorage.removeItem(STORAGE_KEY);
  } catch (e) { /* noop */ }
}
